const Enum = require('./Enum').default;

// US States with VCA Internal ID
const State = new Enum({
  'Alabama': 113,
  'Alaska': 64,
  'Arizona': 65,
  'Arkansas': 66,
  'California': 67,
  'Colorado': 68,
  'Connecticut': 69,
  'Delaware': 70,
  'Florida': 71,
  'Georgia': 72,
  'Hawaii': 73,
  'Idaho': 74,
  'Illinois': 75,
  'Indiana': 76,
  'Iowa': 77,
  'Kansas': 78,
  'Kentucky': 79,
  'Louisiana': 80,
  'Maine ': 81,
  'Maryland': 82,
  'Massachusetts': 83,
  'Michigan': 84,
  'Minnesota': 85,
  'Mississippi': 86,
  'Missouri': 87,
  'Montana': 88,
  'Nebraska': 89,
  'Nevada': 90,
  'New Hampshire': 91,
  'New Jersey': 92,
  'New Mexico': 93,
  'New York': 94,
  'North Carolina': 95,
  'North Dakota': 96,
  'Ohio': 97,
  'Oklahoma': 98,
  'Oregon': 99,
  'Pennsylvania': 100,
  'Puerto Rico': 117,
  'Rhode Island': 101,
  'South Carolina': 102,
  'South Dakota': 103,
  'Tennessee': 104,
  'Texas': 105,
  'Utah': 106,
  'Vermont': 107,
  'Virginia': 108,
  'Washington': 109,
  'Washington D.C': 126,
  'West Virginia': 112,
  'Wisconsin': 110,
  'Wyoming': 111
});

module.exports = {
  State
};